import { CircularProgress } from '@mui/material'
import { FormFieldAutocomplete } from 'global/components/Form'
import { useDebouncedValue } from 'hooks'
import { useState } from 'react'
import { Tecnico, usuarios } from 'service/api'

const MIN_CARACTERES = 2

export default function AutocompleteTecnico() {
    const [busca, setBusca] = useState('')
    const digitado = busca.trim()
    const search = useDebouncedValue(digitado, 300)
    const habilitado = search.length >= MIN_CARACTERES

    const { data = [], isFetching } = usuarios.tecnicos.useFetch<Tecnico[]>({
        queryParams: { search },
        enabled: habilitado,
        keepPreviousData: false,
    })

    /**
     * Cobre também a janela do debounce: sem isso o campo fica sem feedback
     * nos 300ms entre a digitação e o início da requisição.
     */
    const carregando =
        digitado.length >= MIN_CARACTERES && (isFetching || digitado !== search)

    return (
        <FormFieldAutocomplete
            name="Tecnico"
            label="Técnico responsável"
            required
            options={habilitado ? data : []}
            onInputChange={setBusca}
            getOptionLabel={option => `${option.nome} (${option.email})`}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            noOptionsText={(() => {
                if (carregando) return 'Buscando técnicos...'
                if (habilitado) return 'Nenhum técnico encontrado'
                return 'Digite ao menos 2 caracteres'
            })()}
            InputProps={{
                endAdornment: carregando ? (
                    <CircularProgress color="inherit" size={16} />
                ) : null,
            }}
        />
    )
}
